var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c("h4", { staticClass: "mb-30" }, [
                    _vm._v("贴牌代理续费金额设置"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "el-form-item",
                      {
                        staticClass: "mr-30",
                        attrs: { label: item.service_name },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            model: {
                              value: item.service_price,
                              callback: function ($$v) {
                                _vm.$set(item, "service_price", $$v)
                              },
                              expression: "item.service_price",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("元")])],
                          2
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }